import { SVGProps } from 'react';

export const IconSearch = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox='0 0 20 20' {...props}>
      <path
        d='M9.33335 14.6667C12.2789 14.6667 14.6667 12.2789 14.6667 9.33335C14.6667 6.38782 12.2789 4 9.33335 4C6.38782 4 4 6.38782 4 9.33335C4 12.2789 6.38782 14.6667 9.33335 14.6667Z'
        fill='none'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M16 16L13.1 13.1'
        stroke='currentColor'
        fill='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
